<div class="re-issues"
    [ngClass]="{ 'disabled': disabled }"
>
    <div class="issue_icon big"
        matTooltip="RE no activada/caducada"
        [ngClass]="{ filled: flags[0] }"
        (click)="onFlagClick(0, $event)"
    > 1+2
    </div>
    <div class="issue_icon"
        matTooltip="Dosis insuficiente"
        [ngClass]="{ filled: flags[2] }"
        (click)="onFlagClick(2, $event)"
    > 3
    </div>
    <div class="issue_icon"
        matTooltip="No congruente"
        [ngClass]="{ filled: flags[3] }"
        (click)="onFlagClick(3, $event)"
    > 4
    </div>
    <div class="issue_icon"
        [matTooltip]="getTooltip5()"
        [ngClass]="{ filled: flags[4], popover_active: activePopover === 4 }"
        (click)="onFlagClick(4, $event)"
    > 5
    </div>
    <div class="issue_icon"
        [matTooltip]="getTooltip6()"
        [ngClass]="{ filled: flags[5], popover_active: activePopover === 5 }"
        (click)="onFlagClick(5, $event)"
    > 6
    </div>
    <div class="issue_icon"
        matTooltip="Bloqueada por papel"
        [ngClass]="{ filled: flags[6] }"
        (click)="onFlagClick(6, $event)"
    > 7
    </div>
    <div class="issue_icon big"
        matTooltip="PRM"
        [ngClass]="{ filled: flags[7] }"
        (click)="onFlagClick(7, $event)"
    > PRM
    </div>
</div>

<div class="popover-overlay" *ngIf="activePopover !== null"
    [ngStyle]="{ 'top.px': popoverPosition.top, 'left.px': popoverPosition.left }"
    (mousedown)="$event.stopPropagation()"
>
    <div class="popover-arrow"></div>
    <div class="popover-content">
        <ng-container *ngIf="activePopover === 4">
            <mat-checkbox [(ngModel)]="popoverAgudo">Agudo</mat-checkbox>
        </ng-container>
        <ng-container *ngIf="activePopover === 5">
            <mat-form-field class="popover-date-field" appearance="fill">
                <div class="label">Fecha</div>
                <input matInput
                    [matDatepicker]="issueDatepicker"
                    [min]="today"
                    [(ngModel)]="popoverDate"
                >
                <mat-datepicker-toggle matSuffix [for]="issueDatepicker">
                    <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #issueDatepicker></mat-datepicker>
            </mat-form-field>
        </ng-container>
        <button mat-icon-button color="primary" (click)="confirmPopover()">
            <mat-icon>check</mat-icon>
        </button>
    </div>
</div>
